import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Province-Service: ";
const PROVINCE_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/province';

export default class ProvinceService {

    static async readAllProvincePaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, ['countryTranslatedName'], ['country.name']);
        await WrapperService.get(PROVINCE_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveProvince(province, successF, errorF) {
        if (typeof province.id === 'undefined' || province.id === null) {
            await WrapperService.post(PROVINCE_API_URL, province, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(PROVINCE_API_URL + '/' + province.id, province, settingsServiceName, successF, errorF);
        }
    }
}